import { render } from "./PostDetails.vue?vue&type=template&id=00b1f153&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"

import "./post-details.scss?vue&type=style&index=0&id=00b1f153&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b1f153"]])

export default __exports__